import NotFound from './NotFound/NotFound';

export { NotFound };
export default NotFound;
